import dashboard from "./dashboard.json";

const frDashboard = {
    ...dashboard
}

export default frDashboard;
